/**
 * converts a regular Date object to UTC timezone
 * @param {Date|string|number} date
 * @returns {boolean|Date}
 */
export const toUtcDate = date => {
    if (!date) {
        return false
    }

    let dateObj

    if (typeof date === 'string' || typeof date === 'number') {
        dateObj = new Date(date)
    } else if (date instanceof Date) {
        dateObj = date
    } else {
        return false
    }

    return new Date(
        dateObj.getUTCFullYear(),
        dateObj.getUTCMonth(),
        dateObj.getUTCDate(),
        dateObj.getUTCHours(),
        dateObj.getUTCMinutes(),
        dateObj.getUTCSeconds()
    )
}
